<template>
    <component :is="parentWrapper" class="pa-0">
        <v-container fluid grid-list-md white mt-3>
            <payment
                v-if="active"
                @cancel="onCancel"
                @success="$emit('onNextStep', $event)"
                processing
                @received="$emit('onNextStep', {...$event, paid: false})"
            />
        </v-container>
    </component>
</template>

<script>
import StepBase from '@breakmedia/prime-vue-stepper/src/StepBase';

export default {
    //do not set the name - it will break the integration with vuetify stepper
    extends: StepBase,
    data() {
        return {
            routed: true,
        };
    },
    props: {
        route: {
            default: 'payment-processing',
        },
    },
    methods: {
        onCancel() {
            this.$order.clearOrder();
            this.$emit('goToStep', {
                route: 'summary',
            });
        }
    }
};
</script>
